import {
	CallAudioUploadDescriptor,
	CallAudioUploadFailureType,
	CallAudioUploadFailureDescriptor
} from '../state/callAudioUploadState';
import { CallDetails } from '../../models/dto/call';

export function queueCallAudioUploads(uploads: CallAudioUploadDescriptor[], failureIdsToClear: string[], failuresToAdd: CallAudioUploadFailureDescriptor[]): QueueCallAudioUploads {
	return { type: 'call-audio-upload/queue-uploads', uploads, failureIdsToClear, failuresToAdd };
}

export function callAudioUploadStarted(uploadId: string): CallAudioUploadStarted {
	return { type: 'call-audio-upload/upload-started', uploadId };
}

export function callAudioUploadFinishing(uploadId: string): CallAudioUploadFinishing {
	return { type: 'call-audio-upload/upload-finishing', uploadId };
}

export function callAudioUploadSucceeded(uploadId: string, jobId: number, call: CallDetails): CallAudioUploadSucceeded {
	return { type: 'call-audio-upload/upload-succeeded', uploadId, jobId, call };
}

export function callAudioUploadFailed(uploadId: string, description: string, failureType: CallAudioUploadFailureType | nundefined): CallAudioUploadFailed {
	return { type: 'call-audio-upload/upload-failed', uploadId, description, failureType };
}

export interface QueueCallAudioUploads {
	type: 'call-audio-upload/queue-uploads';
	uploads: CallAudioUploadDescriptor[];
	failureIdsToClear: string[];
	failuresToAdd: CallAudioUploadFailureDescriptor[];
}

export interface CallAudioUploadStarted {
    type: 'call-audio-upload/upload-started';
    uploadId: string;
}

export interface CallAudioUploadFinishing {
    type: 'call-audio-upload/upload-finishing';
    uploadId: string;
}

export interface CallAudioUploadSucceeded {
    type: 'call-audio-upload/upload-succeeded';
	uploadId: string;
	jobId: number;
	call: CallDetails;
}

export interface CallAudioUploadFailed {
    type: 'call-audio-upload/upload-failed';
	uploadId: string;
	description: string;
	failureType: CallAudioUploadFailureType | nundefined;
}

export type CallAudioUploadActions = QueueCallAudioUploads | CallAudioUploadStarted | CallAudioUploadFinishing | CallAudioUploadSucceeded | CallAudioUploadFailed;